import { useAppSelector } from '@app/hooks/redux';
import { StateType } from '@app/types/reducer-state';

/** Maps requested permissions to true when they appear in the user's auth list. A leading `!` is stripped before matching. */
export const getPermissionMap = (
  authPermissions: string[] = [],
  permissions: string[] = [],
) => {
  const normalizedPermissions = permissions.map((p) =>
    p?.startsWith('!') ? p.slice(1) : p,
  );
  return authPermissions.reduce(
    (acc: Record<string, boolean>, permission) => {
      if (normalizedPermissions.includes(permission)) {
        acc[permission] = true;
      }
      return acc;
    },
    {} as Record<string, boolean>,
  );
};

export const usePermissionVerify = (permissions: Array<string>) => {
  const authPermissions = useAppSelector(
    ({ auth }: StateType) => auth?.permissions,
  );
  return getPermissionMap(authPermissions, permissions || []);
};

export const useHasAllPermissions = (permissions?: Array<string> | null) => {
  const neededPermissions = permissions ?? [];
  const permissionMap = usePermissionVerify(neededPermissions);
  return neededPermissions.every(
    (permission) => permissionMap[permission] === true,
  );
};

export default usePermissionVerify;
